import { render, staticRenderFns } from "./profilePost.vue?vue&type=template&id=711e2882&"
import script from "./profilePost.vue?vue&type=script&lang=js&"
export * from "./profilePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports